const zh = {
  avisoLegal: "根据 NuvliPro 中登记的数据生成的参考草稿，不能替代专业意见。提交前请与您的会计师核对。",
  lockPago: "为会计师导出文件是付费功能。",
  imp: { IVA: "增值税", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "普通税区", canarias: "加那利群岛", ceuta_melilla: "休达和梅利利亚", foral_pv: "巴斯克地区", foral_navarra: "纳瓦拉" },
  tipo: { autonomo: "个体经营者（自然人）", sociedad: "公司" },
  q: { 1: "第1季度 · 1–3月", 2: "第2季度 · 4–6月", 3: "第3季度 · 7–9月", 4: "第4季度 · 10–12月" },
  periodoT: "{{year}}年第{{n}}季度",
  periodoP: "{{year}}年第{{n}}期预缴",
  sub: "按季度的{{imp}}与个人所得税及年度汇总",
  pie: "金额根据您每季度开具的发票和登记的支出自动计算。",
  regimen: {
    proTitulo: "Pro 套餐：",
    proTexto: "按地区自动识别税制（增值税、IGIC 及地方税务局）、加那利群岛 420 表、公司 202 表、111 表、申报期限提醒及数据质量检查。",
    pasarPro: "升级到 Pro",
    modelo: "（{{m}}表）",
    pagos: "预缴税款：{{m}}表",
    corregido: "已手动更正 · 修改",
    detectado: "已自动识别 · 更正",
    faltan: "缺少您的税务信息（{{que}}）：在您补全之前，我们暂按普通税区和个体经营者处理。",
    cp: "邮政编码", nif: "NIF/CIF", y: "和",
    foral: "您的税务地址位于{{nombre}}：增值税和预缴税款需向{{hacienda}}申报，使用其专用表格和期限。本草稿仅供参考，申报由您的会计师准备。",
    ipsi: "休达和梅利利亚适用 IPSI 而非增值税。NuvliPro 暂不计算该税：请让您的会计师准备申报。",
  },
  card: {
    baseVentas: "销售税基", baseGastos: "支出税基", rep: "销项{{imp}}", sop: "进项{{imp}}",
    irpf: "预扣个人所得税（IRPF）", horas: "工作时长", bases: "按{{imp}}税率的税基", base: "{{imp}} {{pct}}% · 税基",
    resultado: "{{imp}}结果（{{estado}}）", aIngresar: "应缴", aCompensar: "待抵扣",
    igicCanarias: "IGIC · 加那利群岛工程", ivaFuera: "增值税 · 加那利群岛以外工程",
    ipsiRep: "销项 IPSI", ipsiAviso: "IPSI 未计算：由您的会计师准备。",
    isp: "反向征收 · 单独列示", ispEmitidas: "开具（税基，不含税）", ispRecibidas: "收到（税基）",
    ispCuota: "自行核算税额（申报并抵扣）",
  },
  btn: {
    docGestoria: "会计师文件", docAnual: "会计师文件（年度）", enviar: "发送", m: "{{m}}表", modelo: "{{m}}表",
    m420Pro: "420表：Pro 套餐", excel: "Excel", ver130: "查看 130",
  },
  anual: { titulo: "{{year}}年度汇总", ipsi: "销项 IPSI（未计算）", resultado: "年度{{imp}}结果" },
  doc: { gestoria: "会计师文件", modelo: "{{m}}表" },
  toast: {
    generado: "已生成{{doc}}", trimestre: "（第{{n}}季度）", anual: "（{{year}}年度）", error: "无法生成：{{doc}}",
    excelOk: "已为会计师导出{{year}}年报告（XLSX）", excelError: "无法导出报告",
    m130Error: "无法计算 130 表", reduccionError: "无法保存减免",
  },
  m130: {
    titulo: "130表 — 个人所得税", acum: "（累计至第{{n}}季度）", anual: "（{{year}}年度）",
    desc: "本年度累计预缴税款，减去预扣税款及以前季度已缴金额。",
    ingresos: "应计收入（累计）", gastos: "可扣除支出（累计）", rendimiento: "净收益",
    reduccion: "难以举证费用减免 {{pct}} %", pago: "预缴税款（{{pct}} %）",
    retenciones: "已被预扣税款", anteriores: "以前季度已缴",
    aIngresar: "应缴结果", negativo: "结果为负（应缴：0 €）",
    marcar: "适用 {{pct}} % 的难以举证费用减免（每年最多 {{max}}）。请与您的会计师确认。",
    cerrar: "关闭", pdf: "下载 PDF",
  },
  m202: {
    titulo: "202表 — {{year}}年预缴税款（估算）",
    desc: "公司所得税：本年度累计利润的 {{pct}} %。您的会计师可能采用其他方式。",
    plazo: "第{{p}}期 · {{mes}}1日至20日申报", mes: { 1: "4月", 2: "10月", 3: "12月" },
    tramo: { 3: "1–3月", 9: "1–9月", 11: "1–11月" }, beneficio: "累计利润（{{tramo}}）",
    cuota: "利润的 {{pct}} %", menos: "预扣税款及以前预缴", estimacion: "估算应缴",
  },
  m111: {
    titulo: "111表 — {{year}}年预扣税款",
    desc: "工资预扣（由您手动填写）以及向专业人士付款时的预扣（来自您的支出）。",
    nominas: "工资预扣（手动）", profesionales: "专业人士：{{n}} 位收款人，税基 {{base}}",
    total: "应缴合计", guardado: "已保存第{{n}}季度工资预扣",
    errorGuardar: "无法保存金额", invalido: "请输入有效金额，例如 1234.56",
  },
  enviar: {
    titulo: "将{{year}}年第{{n}}季度发送给您的会计师",
    desc: "会计师将收到一封附有这些 PDF 的邮件。如果对方回复，邮件会发给您。",
    email: "会计师邮箱", placeholder: "accountant@example.com", boton: "发送", ok: "{{year}}年第{{n}}季度已发送至 {{email}}（{{docs}} 个 PDF）",
    error: "请检查会计师邮箱",
  },
  avisos: {
    plazos: "即将到期", sinPlazos: "暂无即将到期的申报。",
    forales: "地方税务期限：表格需向您所在的地方税务局申报，由您的会计师准备。",
    modelos: "{{m}}表", rango: "{{periodo}}：{{desde}}至{{hasta}}",
    hoy: "今天截止", unDia: "剩余 1 天", dias: "剩余 {{n}} 天",
    recordatorio: "我们会在每个申报期截止前 10 天通过通知和邮件提醒您。",
    calidad: "{{year}}年数据质量", ok: "一切正常：今年的发票中没有缺失数据。",
    revisar: "查看", exenta: "标记为免税", exentaOk: "支出已标记为免税", exentaError: "无法标记该支出",
  },
  calidad: {
    facturas_nif: "开具的发票缺少客户 NIF 或 NIF 不正确",
    facturas_cp_obra: "工程发票缺少工程邮政编码（请在工程资料中补充）",
    gastos_sin_impuesto: "收到的发票未单独列出税额（增值税或 IGIC 为 0）",
    gastos_nif: "收到的发票缺少供应商 NIF 或 NIF 不正确",
  },
  ajustes: {
    titulo: "税制（季度报表）", det1: "自动识别：", det2: "根据您的邮政编码，以及",
    det3: "根据您的 NIF/CIF。仅在不正确时修改。",
    nota: "此更改仅影响季度报表。新发票仍会根据您和客户的邮政编码建议税种。",
    territorio: "税区", tipo: "纳税人类型", automatico: "自动（{{x}}）",
    autonomo130: "个体经营者（130表）", sociedad202: "公司（202表）",
    bloqueado: "自动税制属于 Pro 套餐。", guardado: "税制已保存", error: "无法保存",
  },
};

export default zh;
